import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {ClassroomAddStore} from './ClassroomAddStore';

@observer
export class ClassroomAddControls extends React.Component<{ store: ClassroomAddStore }> {
  render() {
    const store = this.props.store;
    const isPending = store.save?.isPending === true;

    return (<>
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.parent.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.parent.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Adding classroom" state={store.save} align="right"/>
    </>);
  }
}
